import L from "leaflet";
import React from "react";
import { Marker, Popup } from "react-leaflet";
import { Warp } from "../../../types/Warps";
import store from "../../../assets/store.png";
import { sendWarpEvent } from "../../../helper/WebsocketClient";
import { coreDataStore } from "../../../helper/CoreDataStorage";

interface Props {
  shop_data: Warp;
  x: number;
  y: number;
}

const ShopMarker: React.FC<Props> = ({ shop_data, y, x }) => {
  const icon = L.divIcon({
    html: `
     <div class="w-full h-full flex items-center justify-center pointer-events-none">
    <div class=" bg-white border-2 border-violet-300 rounded-full pointer-events-none">
      <img src="${store}" class="w-[30px] h-[30px] pointer-events-none" />
    </div>
  </div>
  `,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
    className: "",
  });

  return (
    <Marker position={[y, x]} icon={icon}>
      <Popup className="shop-popup">
        <div className="w-[200px] h-auto bg-gray-900 text-white rounded-lg overflow-hidden">
          {shop_data.image && (
            <img
              src={shop_data.image}
              className="w-full h-24 object-cover"
              alt=""
            />
          )}

          <div className="p-2 flex flex-col items-start justify-between select-none">
            <h1 className="text-xl">{shop_data.name}</h1>
            <p className="bg-violet-600 rounded-full px-2 py-1 text-xs">Shop</p>
            <h2 className="text-base">{shop_data.description}</h2>
            <button
              className="mt-3 w-full bg-transparent hover:opacity-80 border-2 text-white py-2 rounded-xl"
              onClick={() => {
                if (
                  coreDataStore.ws &&
                  coreDataStore.session_token &&
                  coreDataStore.ws.OPEN
                ) {
                  sendWarpEvent(
                    coreDataStore.ws,
                    coreDataStore.session_token,
                    shop_data,
                  );
                }
              }}
            >
              Click to warp
            </button>
          </div>
        </div>
      </Popup>
    </Marker>
  );
};

export default ShopMarker;
